export default __webpack_public_path__ + "static/media/hop01.40d97d75.png";